import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";
import api, { createDecoder } from "../../api";
import { nativeVersionResponseT } from "dora-contracts";
import { appVersion } from "../../../helpers/mobile";

const prefix = "app/native-version";

const version = appVersion;

interface State {
  appMajorVersion: number | null;
  shouldShowUpdateModal: boolean;
}

const initialState: State = {
  appMajorVersion: version ? parseInt(version.split(".")[0]) : null,
  shouldShowUpdateModal: false,
};

export const showVersionUpdateModal = createAction(
  `${prefix}/setShouldShowModal`
);

export const hideVersionUpdateModal = createAction(
  `${prefix}/setShouldHideModal`
);

export const loadNativeVersion = createAsyncThunk(
  prefix,
  async (platform: "android" | "ios", thunkApi) => {
    const { getState, dispatch } = thunkApi;
    const state = getState() as RootState;

    const response = await api(thunkApi).get({
      url: "/native-app/native-version",
      decoder: createDecoder(nativeVersionResponseT),
      noChangeConnectionStateOnError: true,
    });
    const serverVersion = response[platform];
    const [major] = serverVersion.split(".").map(Number);
    if (state.app.nativeVersion.appMajorVersion === null) {
      throw new Error(
        "Could not resolve local app version while loading latest native version number"
      );
    }
    if (major > state.app.nativeVersion.appMajorVersion) {
      dispatch(showVersionUpdateModal());
    }
  }
);

const slice = createSlice({
  name: "app/version",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(showVersionUpdateModal, (state) => {
        state.shouldShowUpdateModal = true;
      })
      .addCase(hideVersionUpdateModal, (state) => {
        state.shouldShowUpdateModal = false;
      });
  },
});

export default slice.reducer;
